import React from 'react';
import {DialogContent, Stack} from '@mui/material';
import {BaseDialog} from '@resurs-internal/mui';
import {useHTMLDialog, useTranslate} from 'hooks';
import {DangerousHTML} from '../DangerousHTML';

export const HTMLDialog: React.FC = () => {
  const dialog = useHTMLDialog();
  const open = dialog.state?.type === 'html';
  const translate = useTranslate();

  return (
    <BaseDialog
      actions={[{title: translate('common.close'), onClick: dialog.onClose}]}
      maxWidth="lg"
      onClose={dialog.onClose}
      open={open}
      title={dialog.state?.title}>
      <DialogContent>
        <Stack spacing={3} my={8} sx={{px: {xs: 0, sm: 1}}}>
          <DangerousHTML text={dialog.state?.body ?? ''} />
        </Stack>
      </DialogContent>
    </BaseDialog>
  );
};
